import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { AnimationType } from "../../types/animations";
import { ANIMATION_PRESETS } from "./presets";

const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.min");

interface AnimationControlPanelProps {
  setSelectedAnimation: React.Dispatch<React.SetStateAction<AnimationType>>;
  animationSpeed: number;
  setAnimationSpeed: (speed: number) => void;
  onQueueAnimation?: (animation: AnimationType) => void;
  queuedAnimations?: AnimationType[];
}

const AnimationControlPanel: React.FC<AnimationControlPanelProps> = ({
  setSelectedAnimation,
  animationSpeed,
  setAnimationSpeed,
  onQueueAnimation,
  queuedAnimations = [],
}) => {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = Array.from(tooltipTriggerList).map((tooltipTriggerEl) =>
      new bootstrap.Tooltip(tooltipTriggerEl)
    );
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);

  return (
    <div>
      <div className="container mb-3">
        <div className="mt-4">
          <label htmlFor="animationSpeed" className="form-label">
            Animation Speed
          </label>
          <input
            type="range"
            className="form-range"
            min="1"
            max="10"
            value={animationSpeed}
            onChange={(event) => setAnimationSpeed(Number(event.target.value))}
          />
          <span>{animationSpeed}s</span>
        </div>
        <span className="sidebar-divider"></span>
        <label className="form-label">Select Animation</label>
        <div className="row">
          {ANIMATION_PRESETS.map((animation) => {
            const isQueued = queuedAnimations.includes(animation.value as AnimationType);
            return (
              <div
                key={animation.value}
                className={`col-3 d-flex flex-column align-items-center mb-2 animation-preset ${
                  isQueued ? "is-queued" : ""
                }`}
                role="button"
                aria-label={animation.label}
                onClick={() => setSelectedAnimation(animation.value as AnimationType)}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title={animation.label}
              >
                <div className="animation-preset-icon">
                  <Icon icon={animation.icon} width="36" height="36" />
                  {onQueueAnimation && (
                    <Button
                      size="sm"
                      variant="light"
                      className="animation-queue-button"
                      onClick={(event) => {
                        event.stopPropagation();
                        onQueueAnimation(animation.value as AnimationType);
                      }}
                      aria-label={`Add ${animation.label} to timeline`}
                    >
                      <Icon icon="solar:add-square-linear" width="16" height="16" />
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AnimationControlPanel;
